import {
  calculateAllFinancialSupport,
  calculateFinancialSupport,
  toCurrency,
} from "../../../helpers";
import { PROGRAM_TYPES, HOUSING_TYPES_MAP } from "../../program/constants";

const getProgramTypeName = (id): string => {
  return PROGRAM_TYPES.find((type) => type.id == id)!.name;
};

export function parseProgramListItemSecondaryToFrontEndModel(backEndModel) {
  const tuition = backEndModel.tuition;

  const otherFees = (backEndModel.otherFees ?? []).reduce(
    (sum, fee) => sum + fee.amount,
    0,
  );

  const commissionAmount = calculateFinancialSupport(
    tuition,
    true,
    backEndModel.commissionType,
    backEndModel.commissionAmount,
  );

  const tuitionScholarship = calculateFinancialSupport(
    tuition,
    backEndModel.hasTuitionScholarship,
    backEndModel.tuitionScholarshipType,
    backEndModel.tuitionScholarshipAmount,
  );

  const tuitionFinancialAid = calculateFinancialSupport(
    tuition,
    backEndModel.hasTuitionFinancialAid,
    backEndModel.tuitionFinancialAidType,
    backEndModel.tuitionFinancialAidAmount,
  );

  const otherFeesScholarship = calculateFinancialSupport(
    otherFees,
    backEndModel.hasOtherFeesScholarship,
    backEndModel.otherFeesScholarshipType,
    backEndModel.otherFeesScholarshipAmount,
  );

  const otherFeesFinancialAid = calculateFinancialSupport(
    otherFees,
    backEndModel.hasOtherFeesFinancialAid,
    backEndModel.otherFeesFinancialAidType,
    backEndModel.otherFeesFinancialAidAmount,
  );

  const housingTypes = backEndModel.housingTypes.map(
    (type) => HOUSING_TYPES_MAP[type],
  );

  return {
    id: backEndModel.id,
    programType: getProgramTypeName(backEndModel.programType),
    majorName: backEndModel.majorName,
    intakes: [...backEndModel.intakes],
    tuition: toCurrency(tuition, backEndModel.currency, " "),
    otherFees: toCurrency(
      backEndModel.otherFees.reduce((total, fee) => total + fee.amount, 0),
      backEndModel.currency,
      " ",
    ),
    isActive: backEndModel.isActive,
    commissionAmount: toCurrency(commissionAmount, backEndModel.currency, " "),
    scholarship: calculateAllFinancialSupport(
      tuitionScholarship,
      otherFeesScholarship,
      backEndModel.currency,
    ),
    financialAid: calculateAllFinancialSupport(
      tuitionFinancialAid,
      otherFeesFinancialAid,
      backEndModel.currency,
    ),
    housingTypes,
    boardingAmount: toCurrency(
      backEndModel.boardingAmount,
      backEndModel.currency,
      " ",
    ),
    homestayAmount: toCurrency(
      backEndModel.homestayAmount,
      backEndModel.currency,
      " ",
    ),
    insuranceAmount: toCurrency(
      backEndModel.insuranceAmount,
      backEndModel.currency,
      " ",
    ),
  };
}
